import { appLog } from '~src/utils/log';
import { apiCweb } from './api-cweb';

export type RegistrationLabel = {
  id: number;
  project_id: number;
  name: string;
  order: number;
  state: LabelState;
  created_by: number;
  created_at: number;
  updated_by: number;
  updated_at: number;
  labels: Label[];
};

export type Label = {
  id: number;
  title: string;
  order: number;
  state: LabelState;
  created_by: number;
  created_at: number;
  updated_by: number;
  updated_at: number;
};

type LabelState = {
  NONE: number;
  DRAFT: number;
  PARTIAL: number;
  AVAILABLE: number;
  ACCEPTED: number;
  REJECTED: number;
  COMPLETED: number;
  PROCESSED: number;
  VALIDATED: number;
  REMOVED: number;
  DELETED: number;
  EXPIRED: number;
};

export const getGroups = async (
  _,
  { projectId, show_deleted }: { projectId: number; show_deleted: boolean }
) => {
  appLog('getGroups ->', { projectId, show_deleted });
  const res = await apiCweb.get<RegistrationLabel[]>(
    `/projects/${projectId}/registration_label_groups`,
    {
      params: { show_deleted },
    }
  );
  return res.data;
};

export const createGroup = async ({
  projectId,
  ...rest
}: {
  projectId: number;
  name: string;
  order: number;
}) => {
  appLog('createGroup ->', { projectId, rest });
  const res = await apiCweb.post(
    `/projects/${projectId}/registration_label_groups`,
    {
      ...rest,
    }
  );
  return res.data;
};

export const deleteGroup = async ({
  projectId,
  groupId,
}: {
  projectId: number;
  groupId: number;
}) => {
  appLog('deleteGroup ->', { projectId, groupId });
  const res = await apiCweb.delete(
    `/projects/${projectId}/registration_label_groups/${groupId}`
  );
  return res.data;
};

export const updateGroup = async ({
  projectId,
  groupId,
  data,
}: {
  projectId: number;
  groupId: number;
  data: { name: string; order: number };
}) => {
  appLog('updateGroup ->', { projectId, groupId, data });
  const res = await apiCweb.put(
    `/projects/${projectId}/registration_label_groups/${groupId}?action=update`,
    {
      ...data,
    }
  );
  return res.data;
};

export const updateGroupsOrder = async (
  _,
  {
    projectId,
    ...rest
  }: {
    projectId: number;
    groups: { group_id: number; order: number }[];
  }
) => {
  appLog('updateGroupsOrder ->', { projectId, rest });
  const res = await apiCweb.patch(
    `/projects/${projectId}/registration_label_groups`,
    rest.groups
  );
  return res.data;
};

export const createGroupLabel = async ({
  projectId,
  groupId,
  data,
}: {
  projectId: number;
  groupId: number;
  data: { title: string; order: number }[];
}) => {
  appLog('createGroupLabel ->', { projectId, groupId, data });
  const res = await apiCweb.post(
    `/projects/${projectId}/registration_label_groups/${groupId}/labels`,
    data
  );
  return res.data;
};

export const editGroupLabel = async ({
  projectId,
  groupId,
  labelId,
  data,
}: {
  projectId: number;
  groupId: number;
  labelId: number;
  data: {
    title: string;
    order: number;
  };
}) => {
  appLog('createGroupLabel ->', { projectId, groupId, labelId });
  const res = await apiCweb.put(
    `/projects/${projectId}/registration_label_groups/${groupId}/labels/${labelId}?action=update`,
    data
  );
  return res.data;
};

export const deleteGroupLabel = async ({
  projectId,
  groupId,
  labelId,
}: {
  projectId: number;
  groupId: number;
  labelId: number;
}) => {
  appLog('deleteGroupLabel ->', { projectId, groupId, labelId });
  const res = await apiCweb.delete(
    `/projects/${projectId}/registration_label_groups/${groupId}/labels/${labelId}`
  );
  return res.data;
};

export const restoreGroupLabel = async ({
  projectId,
  groupId,
  labelId,
  action,
}: {
  projectId: number;
  groupId: number;
  labelId: number;
  action: 'reactivate';
}) => {
  appLog('restoreGroupLabel ->', { projectId, groupId, labelId, action });
  const res = await apiCweb.put(
    `/projects/${projectId}/registration_label_groups/${groupId}/labels/${labelId}?action=${action}`,
    {}
  );
  return res.data;
};

export const restoreGroup = async ({
  projectId,
  groupId,
  action,
}: {
  projectId: number;
  groupId: number;
  action: 'reactivate';
}) => {
  appLog('restoreGroup ->', { projectId, groupId, action });
  const res = await apiCweb.put(
    `/projects/${projectId}/registration_label_groups/${groupId}?action=${action}`,
    {}
  );
  return res.data;
};
